/**
 * @author 韩天尊
 * @time 2024-01-15
 * @version 1.0.0
 * @description 应用配置文件
 */

// 应用配置
export const APP_CONFIG = {
  // 管理端基础URL
  // ADMIN_BASE_URL: process.env.REACT_APP_ADMIN_BASE_URL || 'http://localhost:3000',
  ADMIN_BASE_URL: process.env.REACT_APP_ADMIN_BASE_URL || 'http://lhspfw.haikou.gov.cn/reliefVol',

  
  
  // API服务配置
  // API: {
  //   // 主要业务API服务 (grid-hub)
  //   HUB_BASE_URL: process.env.REACT_APP_HUB_BASE_URL || 'http://localhost:9002/grid-hub/',
    
  //   // 系统管理API服务 (grid-sys)
  //   SYS_BASE_URL: process.env.REACT_APP_SYS_BASE_URL || 'http://localhost:9002/grid-sys/',
    
  //   // 兼容旧配置
  //   BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:9002/grid-hub/',
  // },

  API: {
    // 主要业务API服务 (grid-hub)
    HUB_BASE_URL: process.env.REACT_APP_HUB_BASE_URL || 'http://hkcsdn.hkrxd.com/grid-hub-prod/',
    
    // 系统管理API服务 (grid-sys)
    SYS_BASE_URL: process.env.REACT_APP_SYS_BASE_URL || 'http://hkcsdn.hkrxd.com/grid-sys-prod/',
    
    // 兼容旧配置
    BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://hkcsdn.hkrxd.com/grid-hub-prod/',
  },
  
  // 应用名称
  APP_NAME: '志愿者服务平台',
  
  // 版本号
  VERSION: '1.0.0'
};

// 导出默认配置
export default APP_CONFIG;
